module.exports = __webpack_public_path__ + "static/media/radio_circle.5be849f2.png";